import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import SelectedEmplacementDeliveryInput from '../../components/SelectedEmplacementDeliveryInput';

import { useAxios } from '../../utils/hook/useAxios';

function EmplacementCarDelivery() {
  const [modelId, setModelId] = useState(null);
  const [modelName, setModelName] = useState(null);
  const [resetInput, setResetInput] = useState(true);
  const [vehicleData, setVehicleData] = useState({});
  const { voitureId, annonceId } = useParams();
  const [locationCenter, setLocationCenter] = useState([0, 0]);
  const [locationPlaceName, setLocationPaceName] = useState('');

  const axios = useAxios();

  // Fonctions de rappel pour récupérer les valeurs sélectionnées
  useEffect(() => {
    let fetchReviews = async () => {
      let datavehicule = window.localStorage.getItem('VehicleStorage');
      datavehicule = JSON.parse(datavehicule);
      setVehicleData(datavehicule);
      console.log(datavehicule);
      const response = await axios.get('/vehicles/searchbyid/' + voitureId);
      if (response.data) {
        setVehicleData(response.data);
        setModelId(response.data.modeleId);
        let datavehicle = JSON.stringify(response.data);
        window.localStorage.setItem('VehicleStorage', datavehicle);
      }
    };
    fetchReviews();
  }, []);

  const handleLocationSelection = (locationAddress) => {
    setLocationCenter(locationAddress.center);
    setLocationPaceName(locationAddress.place_name);
  };

  function handleAjouterEmplacement() {
    let fetchReviews = async () => {
      try {
        const response = await axios.post('/deliverylocation', {
          annonceId: annonceId,
          addressEmplacementDelivery: locationPlaceName,
          locationCoords: locationCenter[1].toString() + ',' + locationCenter[0].toString(),
        });

        if (response.data) {
          toast.success("Lieu de l'emplacement et livraison  ajouté  pour votre annonce");

          window.location.href = '/location-mode-car/' + voitureId + '/annonce/' + annonceId; //  "/availabilities-car/" + voitureId;
        }
      } catch (error) {
        console.error('Erreur lors de la requête Axios :', error);
      }
    };
    fetchReviews();
  }

  return (
    <main className="mc-home mc-form-page">
      <div className="mc-form-shell mc-form-shell--narrow">
        <div className="mc-stepper">
          <div className="mc-stepper-top">
            <span>Inscrire ma voiture</span>
            <span>60 %</span>
          </div>
          <div
            className="mc-stepper-bar"
            role="progressbar"
            aria-label="Progression de l'inscription"
            aria-valuenow="60"
            aria-valuemin="0"
            aria-valuemax="100"
          >
            <div className="mc-stepper-fill" style={{ width: '60%' }}></div>
          </div>
        </div>

        <section className="mc-form-card">
          <span className="mc-section-kicker">EMPLACEMENT</span>
          <h1 className="mc-form-title">Où donnerez-vous rendez-vous à votre locataire ?</h1>
          <p className="mc-form-subtitle">
            Indiquez la ville, la gare ou l'aéroport où la voiture sera remise.
          </p>

          <div className="mc-field">
            <SelectedEmplacementDeliveryInput
              handleSelectLocation={handleLocationSelection}
              resetInput={resetInput}
            ></SelectedEmplacementDeliveryInput>
          </div>

          <div className="mc-form-alert mc-form-alert--info" role="note">
            <ion-icon name="lock-closed-outline"></ion-icon>
            <span>
              Pour protéger vos données, nous ne communiquons l'emplacement de votre voiture aux
              invités qu'une fois leur voyage confirmé par vos soins.
            </span>
          </div>

          <div className="mc-form-actions">
            <span></span>
            <button
              type="button"
              className="mc-btn mc-btn--primary"
              onClick={handleAjouterEmplacement}
              disabled={!locationPlaceName}
            >
              Confirmer
              <ion-icon name="arrow-forward-outline"></ion-icon>
            </button>
          </div>
        </section>
      </div>
    </main>
  );
}

export default EmplacementCarDelivery;
